export const detectDebugMode = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get("debug") === "true";
};

export const detectUseDefault = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const value = decodeURIComponent(urlParams.get("useDefault") || "");
    console.log("useDefault param value: ", value);
    return value.toLowerCase() === "true";
};

export const detectCkOid = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const customerKeyxOcid = urlParams.get("exp");
    if (customerKeyxOcid) {
        const [ck, oid] = customerKeyxOcid.split("x");
        return { ck, oid };
    }
}

export const detectYoutubeUrls = (url) => {
    return url.includes("youtube.com") || url.includes("youtu.be");
}

export const detectIOS = () => {
    return (
        /iPad|iPhone|iPod/.test(navigator.userAgent) ||
        (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
    );
};


